import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {Button, Form} from '../../../../shared/components';
import { SignInIcon } from '../../../../assets/icons';
import { formSchema, validationSchema } from './schemas';
import {ROUTES} from "../../../../shared/constants/navigation";
import styles from "./styles";

const Container = styled('div')(styles.container)
const SignInBox = styled('div')(styles.signInBox)
const SignInText = styled('div')(styles.signInText)

const defaultValues = {
  contactSameAsPrimary: true
};

class ContactInformation extends Component {
  constructor(props) {
    super(props);
    const { data } = props;
    this.contactSameAsPrimary = data ? data['contactSameAsPrimary'] : true;
    this.initializing = true;
  }

  trigger = values => {
    if (!values) return false;
    const hasChanged =
      values['contactSameAsPrimary'] !== this.contactSameAsPrimary;
    this.contactSameAsPrimary = values['contactSameAsPrimary'];
    return hasChanged;
  };

  handleSignInClick = () => {
    if(window.location.host.match('manager.baosystems.com')) {
      window.location.pathname = '/app/login/';
    } else {
      window.location = 'https://manager.baosystems.com/app/login/';
    }
  }

  render() {
    const { t, formData: { contactInformation }, history, handleOnDataChange } = this.props;
    const firstStart = this.initializing;
    this.initializing = false;
    const _data = { ...defaultValues, ...contactInformation };

    return (
      <Container>
      <Form
        formId="contactInformation"
        updateInitialValues={this.trigger(_data)}
        validationSchema={validationSchema(t, _data, firstStart)}
        formSchema={formSchema(t, _data, firstStart)}
        title={t('title')}
        onChange={handleOnDataChange}
        nextButton={{
          label: t('nextButtonLabel'),
          action: () => history.push(ROUTES.SIGN_UP_INSTANCES),
          tabIndex: this.contactSameAsPrimary ? 7 : 10
        }}
      />
      <SignInBox>
        <SignInIcon/>
        <SignInText>
          {t("signIn.text")}
        </SignInText>
        <Button
          colored="white"
          type="button"
          onClick={this.handleSignInClick}
        >
          {t("signIn.button")}
        </Button>
      </SignInBox>
      </Container>
    );
  }
}

ContactInformation.propTypes = {
  data: PropTypes.object.isRequired,
  handleOnDataChange: PropTypes.func.isRequired,
  handleNextStepClick: PropTypes.func
};

ContactInformation.defaultProps = {
  data: {}
};

export default ContactInformation;
